export const LevelData: any = {

    LEVEL1: {
        BG: 1,
        SPRITE: {
            BAD: ['enemy1'],
            BADCOUNT: 20,
            GOOD: ['good1', 'good2'],
            GOODCOUNT: 4,
        },
        SPEED: 0.006,
        SPEED_INC: 0.002,
        MARKETING: {

        }
    },

    LEVEL2: {
        BG: 2,
        SPRITE: {
            BAD: ['enemy2'],
            BADCOUNT: 30,
            GOOD: ['good1', 'good2'],
            GOODCOUNT: 6,
        },
        SPEED: 0.008,
        SPEED_INC: 0.003,
        MARKETING: {

        }
    },

    LEVEL3: {
        BG: 3,
        SPRITE: {
            BAD: ['enemy3'],
            BADCOUNT: 40,
            GOOD: ['good1', 'good2'],
            GOODCOUNT: 8,
        },
        SPEED: 0.010,
        SPEED_INC: 0.004,
        MARKETING: {

        }
    },

    LEVEL4: {
        BG: 4,
        SPRITE: {
            BAD: ['enemy4'],
            BADCOUNT: 50,
            GOOD: ['good1', 'good2'],
            GOODCOUNT: 10,
        },
        SPEED: 0.012,
        SPEED_INC: 0.005,
        MARKETING: {

        }
    },

    LEVEL5: {
        BG: 5,
        SPRITE: {
            BAD: ['enemy1','enemy2','enemy3','enemy4','boss'],
            BADCOUNT: 75,
            GOOD: ['good1', 'good2'],
            GOODCOUNT: 15,
        },
        SPEED: 0.014,
        SPEED_INC: 0.006,
        MARKETING: {

        }
    },

}